module.exports = __webpack_public_path__ + "static/media/Sahara_forest_crop_tablet.93683e65.jpg";